/**
 * 处理添加购物车操作
 */
if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector('form');
                if(!this.form) return;

                this.isloading = false;
                this.error = false;
                this.variantIdInput.disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this)); // 添加提交购物车监听

                this.addCartButtons = this.querySelectorAll('button[type="submit"]'); // 添加购物车按钮，可能有多处按钮

                this.cartDrawer = document.getElementById('Cart-Drawer');
                if (this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) this.addCartButtons.forEach(button=>{
                    button.setAttribute('aria-haspopup', 'dialog');
                    button.setAttribute('aria-expanded', 'false');
                    button.setAttribute('aria-controls', 'Cart-Drawer');
                });

                this.errorMessageWrapper = document.getElementById(`Product-Form-Error-Message-${this.dataset.section}`);
                // 快速购物弹窗
                this.quickAddDrawer = this.closest('product-side-drawer');

                // 迷你结账
                this.miniChecker = document.getElementById(`Product-Mini-Checkout-${this.dataset.section}`);
                if(this.miniChecker) {
                    this.miniCheckerObserver = new IntersectionObserver((entries, observer)=>{
                        if(entries[0].isIntersecting) {
                            this.hideMiniCheck();
                        } else if (entries[0].boundingClientRect.top < 0){
                            this.showMiniCheck();
                        }
                    }, {
                        root: null,
                        rootMargin: '-200px 0px 0px 0px'
                    });

                    this.miniCheckerObserver.observe(this);
                }
            }

            disconnectedCallback() {
                if(this.miniCheckerObserver) this.miniCheckerObserver.disconnect();
            }

            get variantIdInput() {
                return this.form.querySelector('[name=id]');
            }
            
            /**
             * 是否隐藏错误信息
             * 当产品是礼品卡的时候，隐藏错误信息
             * @returns {boolean}
             */
            get hideErrors() {
                return this.dataset.hideErrors === 'true';
            }

            /**
             * 处理点击提交购物车
             * @param event
             */
            onSubmitHandler(event) {
                if(this.isloading) return;
                event.preventDefault();

                if(Array.from(this.addCartButtons).find(button => button.hasAttribute('disabled'))) return;

                this.handleErrorMessage();
                this.startLoading();

                const config = webvista.fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];  /* 浏览器会自动为 formData 对象生成带有边界(boundary)的 multipart/form-data 类型*/

                const formData = new FormData(this.form);
                formData.append('sections', this.getSectionsToRender().map((section)=>section.section).join());
                formData.append('sections_url', window.location.pathname);
                config.body = formData;

                fetch(`${window['routes']['cart_add_url']}`, config)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if (response.status) {
                            webvista.publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);
                            return this.error = true;
                        }
                        this.error = false;

                        // 动态更新Sections内容
                        SectionDynamicUpdate.updateSections(this.getSectionsToRender(), response['sections']);

                        webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response,
                        });

                        if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                            // 打开抽屉
                            this.cartDrawer.show(event.submitter);
                        } else {
                            return;
                        }
                    })
                    .catch((e) => {
                        this.handleErrorMessage(window['accessibilityStrings']['unknownError']);
                        this.error = true;
                    })
                    .finally(()=>{
                        this.endLoading();
                        // 关闭迷你结账
                        this.hideMiniCheck();
                    });
            }

            /**
             * 获取需要重新渲染的位置
             * @returns {[{section: string, selector: string, id: string}]}
             */
            getSectionsToRender() {
                const sections = [
                    {
                        id: 'Cart-Icon-Bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section'
                    }
                ];

                if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                    sections.push({
                        id: 'Cart-Drawer',
                        section: this.cartDrawer.dataset.section,
                        selector: '#Cart-Drawer-Details',
                    });
                }

                return sections;
            }

            /**
             * 错误显示
             * @param errorMessage
             */
            handleErrorMessage(errorMessage = null) {
                if (this.hideErrors || !this.errorMessageWrapper) return;

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
                this.errorMessageWrapper.textContent = errorMessage ? errorMessage : '';
            }

            startLoading() {
                this.isloading = true;

                this.addCartButtons.forEach(button => {
                    button.setAttribute('disabled', 'disabled');
                    button.classList.add('loading');
                });
            }

            endLoading() {
                this.isloading = false;

                this.addCartButtons.forEach(button => {
                    button.removeAttribute('disabled');
                    button.classList.remove('loading');
                });

                // 关闭快速预览
                if(!this.error && this.quickAddDrawer) {
                    this.quickAddDrawer.hide();
                }
            }

            showMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.add('active');
            }

            hideMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.remove('active');
            }
        }
    );
}

/**
 * CRO patch: stable complementary products UI on PDP.
 * Replaces Shopify's dynamic recommendations markup when it is cached/filtered,
 * while keeping image/title as quick-view and the green button as AJAX add-to-cart.
 */
(() => {
    const CRO_COMPLEMENTARY_BY_PRODUCT_ID = {
        '10148977115469': [
            'relakabelsats-3st-extraljus-12v-dt-60a-103105-3',
            'obd-ii-y-splitter-dubbel-anslutning-till-bilens-diagnosuttag',
            'canbus-adapter-for-extraljus-helljusstyrning-lazer-lamps',
        ],
    };

    const styleId = 'cro-complementary-product-form-style';

    function addStyles() {
        if (document.getElementById(styleId)) return;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            .section-main-product .cro-complementary-list{display:grid;gap:10px;margin:0}
            .section-main-product .cro-complementary-product-form{margin:0}
            .section-main-product .cro-complementary-row{align-items:center;background:rgba(var(--color-foreground),.04);border:1px solid rgba(var(--color-foreground),.10);border-radius:12px;color:rgb(var(--color-foreground));display:grid;gap:10px;grid-template-columns:1fr auto;min-height:78px;padding:8px;text-align:left;width:100%}
            .section-main-product .cro-complementary-row:hover{border-color:rgba(var(--color-foreground),.24)}
            .section-main-product .cro-complementary-info{align-items:center;color:inherit;cursor:pointer;display:grid;gap:10px;grid-template-columns:64px 1fr;min-width:0;text-decoration:none}
            .section-main-product .cro-complementary-info:hover .cro-complementary-title{text-decoration:underline}
            .section-main-product .cro-complementary-media{align-items:center;aspect-ratio:1;background:rgba(var(--color-foreground),.06);border-radius:10px;display:flex;justify-content:center;overflow:hidden}
            .section-main-product .cro-complementary-media img{height:100%;object-fit:contain;width:100%}
            .section-main-product .cro-complementary-copy{display:grid;gap:3px;min-width:0}
            .section-main-product .cro-complementary-title{font-size:13px;font-weight:600;line-height:1.25}
            .section-main-product .cro-complementary-price{font-size:13px;line-height:1.2}
            .section-main-product .cro-complementary-add-button{align-items:center;background:#0cb771;border:0;border-radius:999px;color:#fff;cursor:pointer;display:inline-flex;font-size:12px;font-weight:700;justify-content:center;min-height:30px;padding:0 12px;white-space:nowrap}
            .section-main-product .cro-complementary-add-button[disabled]{cursor:not-allowed;opacity:.55}
            @media screen and (max-width:749px){.section-main-product .cro-complementary-row{min-height:70px}.section-main-product .cro-complementary-info{grid-template-columns:56px 1fr}.section-main-product .cro-complementary-add-button{font-size:11px;padding:0 10px}}
        `;
        document.head.appendChild(style);
    }

    function formatMoney(cents) {
        const value = Number(cents || 0) / 100;
        return `${value.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} SEK`;
    }

    function productIdFromRecommendations(element) {
        const raw = element && element.getAttribute('data-url');
        if (!raw) return null;
        try {
            const url = new URL(raw, window.location.origin);
            return url.searchParams.get('product_id');
        } catch (error) {
            const match = raw.match(/product_id=(\d+)/);
            return match ? match[1] : null;
        }
    }

    async function fetchProduct(handle) {
        const response = await fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error(`Could not fetch ${handle}`);
        return response.json();
    }

    function renderProduct(product) {
        const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
        if (!variant) return '';
        const image = product.featured_image || (product.images || [])[0] || '';
        const compareAt = variant.compare_at_price && variant.compare_at_price > variant.price
            ? `<s class="cro-complementary-compare">${formatMoney(variant.compare_at_price)}</s>`
            : '';
        return `
            <li class="cro-complementary-item">
                <div class="cro-complementary-row">
                    <button
                        type="button"
                        class="cro-complementary-info"
                        data-product-url="${product.url}"
                        aria-haspopup="dialog"
                        aria-controls="Product-QuickView-Drawer"
                        aria-label="Visa produktinfo för ${product.title.replace(/"/g, '&quot;')}"
                    >
                        <span class="cro-complementary-media">
                            ${image ? `<img src="${image}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
                        </span>
                        <span class="cro-complementary-copy">
                            <span class="cro-complementary-title">${product.title}</span>
                            <span class="cro-complementary-price">${formatMoney(variant.price)} ${compareAt}</span>
                        </span>
                    </button>
                    <product-form class="cro-complementary-form" data-section="cro-complementary">
                        <form method="post" action="/cart/add" class="cro-complementary-product-form" enctype="multipart/form-data" novalidate="novalidate">
                            <input type="hidden" name="form_type" value="product">
                            <input type="hidden" name="utf8" value="✓">
                            <input type="hidden" name="id" value="${variant.id}">
                            <button type="submit" class="cro-complementary-add-button" ${variant.available ? '' : 'disabled'} aria-label="Lägg till ${product.title.replace(/"/g, '&quot;')} i varukorgen">
                                ${variant.available ? 'Lägg till' : 'Slutsåld'}
                            </button>
                        </form>
                    </product-form>
                </div>
            </li>
        `;
    }

    function attachQuickViewHandlers(root) {
        root.querySelectorAll('.cro-complementary-info').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                const drawer = document.getElementById('Product-QuickView-Drawer');
                if (drawer && typeof drawer.show === 'function') {
                    button.setAttribute('data-product-url', button.dataset.productUrl);
                    drawer.show(button);
                } else if (button.dataset.productUrl) {
                    window.location.href = button.dataset.productUrl;
                }
            });
        });
    }

    async function renderComplementaryBlock(element) {
        if (!element || element.dataset.croComplementaryRendered === 'true') return;
        const productId = productIdFromRecommendations(element);
        const handles = CRO_COMPLEMENTARY_BY_PRODUCT_ID[productId];
        if (!handles || handles.length === 0) return;
        element.dataset.croComplementaryRendered = 'true';
        addStyles();
        try {
            const products = await Promise.all(handles.map(fetchProduct));
            element.innerHTML = `
                <h2 class="h4">Komplettera installationen</h2>
                <ul class="list-unstyled cro-complementary-list">
                    ${products.map(renderProduct).join('')}
                </ul>
            `;
            attachQuickViewHandlers(element);
            if (window.webvista && typeof window.webvista.initLazyImages === 'function') {
                window.webvista.initLazyImages();
            }
        } catch (error) {
            element.dataset.croComplementaryRendered = 'false';
        }
    }

    function initCroComplementary() {
        document.querySelectorAll('product-recommendations.product-complementary').forEach(renderComplementaryBlock);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCroComplementary);
    } else {
        initCroComplementary();
    }
    window.addEventListener('load', initCroComplementary);
    setTimeout(initCroComplementary, 1500);
    setTimeout(initCroComplementary, 4000);
})();
